import { gql } from '@apollo/client';

export type Insurance = {
  type: string;
  provider: string;
  preAuth: string;
};

const InsuranceFragment = gql`
  fragment InsuranceFragment on InsuranceInfo {
    type
    provider
    preAuth
  }
`;

export default InsuranceFragment;
